import React, { useState } from 'react';
import { db } from '../services/firebaseConfig';
import { collection, getDocs, deleteDoc, doc, writeBatch } from 'firebase/firestore';

const DatabaseCleaner = () => {
  const [isClearing, setIsClearing] = useState(false);
  const [results, setResults] = useState([]);

  const clearCollections = async () => {
    setIsClearing(true);
    setResults([]);
    
    const collectionsToCheck = [
      'menuItems',
      'products', 
      'categories',
      'shopCategories',
      'pourOverBeans',
      'wholesaleProducts',
      'inventory',
      'inventoryItems'
    ];
    
    const clearResults = [];
    
    for (const collectionName of collectionsToCheck) {
      try {
        console.log(`Checking collection: ${collectionName}`);
        
        const collectionRef = collection(db, collectionName);
        const snapshot = await getDocs(collectionRef);
        
        if (snapshot.empty) {
          clearResults.push(`${collectionName}: Already empty`);
          continue;
        }
        
        const docCount = snapshot.size;
        clearResults.push(`${collectionName}: Found ${docCount} documents`);
        
        // Use batch delete for better performance
        let batch = writeBatch(db);
        let batchCount = 0;
        
        for (const document of snapshot.docs) {
          batch.delete(doc(db, collectionName, document.id));
          batchCount++;
          
          // Firestore batch limit is 500 operations
          if (batchCount === 500) {
            await batch.commit();
            batch = writeBatch(db);
            batchCount = 0;
          }
        }
        
        // Commit remaining batch operations
        if (batchCount > 0) {
          await batch.commit();
        }
        
        clearResults.push(`${collectionName}: ✅ Cleared ${docCount} documents`);
        
      } catch (error) {
        console.error(`Error clearing ${collectionName}:`, error);
        clearResults.push(`${collectionName}: ❌ Error - ${error.message}`);
      }
    }
    
    setResults(clearResults);
    setIsClearing(false);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Database Cleaner</h2>
      <p><strong>Warning:</strong> This will permanently delete all menu items and related data!</p>
      
      <button 
        onClick={clearCollections} 
        disabled={isClearing}
        style={{
          padding: '10px 20px',
          backgroundColor: isClearing ? '#ccc' : '#ff4444',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: isClearing ? 'not-allowed' : 'pointer',
          fontSize: '16px'
        }}
      >
        {isClearing ? 'Clearing Database...' : 'Clear All Menu Data'}
      </button>
      
      {results.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          <h3>Results:</h3>
          <div style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '15px', 
            borderRadius: '5px',
            fontFamily: 'monospace',
            whiteSpace: 'pre-line'
          }}>
            {results.map((result, index) => (
              <div key={index} style={{ margin: '5px 0' }}>
                {result}
              </div>
            ))}
          </div>
        </div>
      )}
      
      {results.length > 0 && !isClearing && (
        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#d4edda', borderRadius: '5px' }}>
          <strong>✅ Database cleared successfully!</strong>
          <br />
          You can now start fresh with your menu items.
        </div>
      )}
    </div>
  );
};

export default DatabaseCleaner;